<template>
  <div :class="`homePage ${toggleTheme ? '' : 'black'}`">
    <div class="homePage__all">
      <div class="homePage__logo">
        <img src="@/assets/logoarm.png" alt="">
        
      </div>
      <div class="homePage__text">
        {{ $t("homepage.lib") }} <span>{{ bookCount.books }}</span>
        {{ $t("homepage.elec") }} <span>{{ bookCount.paperbook }}</span>
        {{ $t("homepage.paper") }}
      </div>
      <div class="homePage__search">
        <el-icon class="homePage__icon"><Search /></el-icon>
        <el-input
          class="homePage__input"
          type="text"
          clearable
          v-model="search"
          :placeholder="$t('header.placeholder')"
          size="large"
          style="width: 600px"
          @keypress.enter="goList(search)"
        />

        <el-scrollbar
          height="400px"
          class="homePage__list"
          v-if="searchHomeGet?.length > 0"
        >
          <div class="homePage__item">
            <span
              @click="goList(item.title)"
              v-for="item of searchHomeGet"
              :key="item._id"
            >
              <div class="name">
                <b>{{ item.title }}</b>
              </div>
            </span>
          </div>
        </el-scrollbar>
      </div>
      <a href="https://unilibrary.uz/" class="homePage__link">
        <svg
          width="170"
          height="40"
          viewBox="0 0 178 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 8H26C28.8284 8 30.2426 8 31.1213 8.87868C32 9.75736 32 11.1716 32 14V34C32 36.8284 32 38.2426 31.1213 39.1213C30.2426 40 28.8284 40 26 40H8V8Z"
            fill="url(#paint0_linear_495_6485)"
          />
          <g filter="url(#filter0_b_495_6485)">
            <path
              d="M0 6C0 3.17157 0 1.75736 0.87868 0.87868C1.75736 0 3.17157 0 6 0H24V32H6C3.17157 32 1.75736 32 0.87868 31.1213C0 30.2426 0 28.8284 0 26V6Z"
              fill="url(#paint1_linear_495_6485)"
            />
          </g>
          <path
            d="M44.5977 11.2344H51.7227V14.457H50.0938V21.8281C50.0938 22.5 50.168 23.0703 50.3164 23.5391C50.4727 24.0078 50.6875 24.3906 50.9609 24.6875C51.2344 24.9844 51.5586 25.2031 51.9336 25.3438C52.3086 25.4766 52.7188 25.543 53.1641 25.543C53.625 25.543 54.043 25.4844 54.418 25.3672C54.8008 25.25 55.125 25.0508 55.3906 24.7695C55.6641 24.4805 55.8711 24.0977 56.0117 23.6211C56.1602 23.1445 56.2344 22.5469 56.2344 21.8281V14.457H54.3477V11.2344H61.4727V14.457H60.0547V21.3711C60.0547 22.6211 59.875 23.7344 59.5156 24.7109C59.1562 25.6797 58.6602 26.5 58.0273 27.1719C57.4023 27.8438 56.6641 28.3555 55.8125 28.707C54.9688 29.0586 54.0625 29.2344 53.0938 29.2344C52.1328 29.2344 51.2344 29.0625 50.3984 28.7188C49.5625 28.3672 48.832 27.8633 48.207 27.207C47.5898 26.543 47.1016 25.7383 46.7422 24.793C46.3828 23.8477 46.2031 22.7773 46.2031 21.582V14.457H44.5977V11.2344ZM73.2266 22.0156C73.2266 21.3359 73.0469 20.8047 72.6875 20.4219C72.3281 20.0312 71.8516 19.8359 71.2578 19.8359C70.8516 19.8359 70.4414 19.9258 70.0273 20.1055C69.6133 20.2852 69.2109 20.6211 68.8203 21.1133V25.7891H70.7891V29H63.2422V25.7891H65.0234V20.0703H63.2656V16.8594H68.7969V17.9258C69.3047 17.5273 69.8711 17.2148 70.4961 16.9883C71.1289 16.7539 71.793 16.6367 72.4883 16.6367C73.9492 16.6367 75.0742 17.0469 75.8633 17.8672C76.6523 18.6797 77.0469 19.8711 77.0469 21.4414V25.7891H78.7695V29H73.2266V22.0156ZM80.3516 16.8594H85.8008V25.7891H87.4883V29H80.3516V25.7891H82.1797V20.0703H80.3516V16.8594ZM81.9922 12.9453C81.9922 12.6562 82.043 12.3867 82.1445 12.1367C82.2539 11.8789 82.4023 11.6562 82.5898 11.4688C82.7773 11.2812 82.9961 11.1328 83.2461 11.0234C83.5039 10.9141 83.7812 10.8594 84.0781 10.8594C84.3594 10.8594 84.625 10.9141 84.875 11.0234C85.125 11.1328 85.3438 11.2812 85.5312 11.4688C85.7188 11.6562 85.8672 11.8789 85.9766 12.1367C86.0859 12.3867 86.1406 12.6562 86.1406 12.9453C86.1406 13.2344 86.0859 13.5078 85.9766 13.7656C85.8672 14.0156 85.7188 14.2344 85.5312 14.4219C85.3438 14.6094 85.125 14.7578 84.875 14.8672C84.625 14.9766 84.3594 15.0312 84.0781 15.0312C83.7812 15.0312 83.5039 14.9766 83.2461 14.8672C82.9961 14.7578 82.7773 14.6094 82.5898 14.4219C82.4023 14.2344 82.2539 14.0156 82.1445 13.7656C82.043 13.5078 81.9922 13.2344 81.9922 12.9453ZM89.3633 10.7656H94.8359V25.7891H96.7109V29H89.3633V25.7891H91.2383V13.9766H89.3633V10.7656ZM98.75 16.8594H104.199V25.7891H105.887V29H98.75V25.7891H100.578V20.0703H98.75V16.8594ZM100.391 12.9453C100.391 12.6562 100.441 12.3867 100.543 12.1367C100.652 11.8789 100.801 11.6562 100.988 11.4688C101.176 11.2812 101.395 11.1328 101.645 11.0234C101.902 10.9141 102.18 10.8594 102.477 10.8594C102.758 10.8594 103.023 10.9141 103.273 11.0234C103.523 11.1328 103.742 11.2812 103.93 11.4688C104.117 11.6562 104.266 11.8789 104.375 12.1367C104.484 12.3867 104.539 12.6562 104.539 12.9453C104.539 13.2344 104.484 13.5078 104.375 13.7656C104.266 14.0156 104.117 14.2344 103.93 14.4219C103.742 14.6094 103.523 14.7578 103.273 14.8672C103.023 14.9766 102.758 15.0312 102.477 15.0312C102.18 15.0312 101.902 14.9766 101.645 14.8672C101.395 14.7578 101.176 14.6094 100.988 14.4219C100.801 14.2344 100.652 14.0156 100.543 13.7656C100.441 13.5078 100.391 13.2344 100.391 12.9453ZM107.41 10.7656H112.707V17.1289C113.129 16.9258 113.562 16.7695 114.008 16.6602C114.453 16.5508 114.91 16.4961 115.379 16.4961C116.277 16.4961 117.109 16.6641 117.875 17C118.641 17.3359 119.301 17.793 119.855 18.3711C120.41 18.9492 120.844 19.625 121.156 20.3984C121.477 21.1719 121.637 21.9922 121.637 22.8594C121.637 23.7344 121.48 24.5586 121.168 25.332C120.863 26.1055 120.434 26.7812 119.879 27.3594C119.324 27.9297 118.664 28.3828 117.898 28.7188C117.133 29.0469 116.293 29.2109 115.379 29.2109C114.887 29.2109 114.418 29.1641 113.973 29.0703C113.527 28.9766 113.105 28.8438 112.707 28.6719V29H109.109V13.9766H107.41V10.7656ZM115.133 19.7305C114.617 19.7305 114.152 19.8477 113.738 20.082C113.332 20.3164 112.988 20.6523 112.707 21.0898V24.7227C112.957 25.0977 113.289 25.4023 113.703 25.6367C114.125 25.8633 114.594 25.9766 115.109 25.9766C115.508 25.9766 115.887 25.9062 116.246 25.7656C116.605 25.6172 116.918 25.4102 117.184 25.1445C117.457 24.8711 117.672 24.5469 117.828 24.1719C117.984 23.7891 118.062 23.3594 118.062 22.8828C118.062 22.3984 117.984 21.9609 117.828 21.5703C117.672 21.1797 117.461 20.8477 117.195 20.5742C116.93 20.3008 116.617 20.0938 116.258 19.9531C115.906 19.8047 115.531 19.7305 115.133 19.7305ZM134.328 21.2773H131.035V20.0234C130.715 20.0234 130.422 20.0469 130.156 20.0938C129.891 20.1328 129.656 20.2031 129.453 20.3047C129.258 20.4062 129.09 20.5469 128.949 20.7266C128.816 20.9062 128.723 21.1289 128.668 21.3945V25.7891H131.141V29H123.219V25.7891H125.035V20.0703H123.242V16.8594H128.645V17.7148C128.988 17.4414 129.375 17.2305 129.805 17.082C130.234 16.9336 130.703 16.8594 131.211 16.8594C131.727 16.8594 132.258 16.8633 132.805 16.8711C133.352 16.8789 133.859 16.8828 134.328 16.8828V21.2773ZM143.785 28.3438C143.512 28.5156 143.262 28.6641 143.035 28.7891C142.809 28.9062 142.582 29 142.355 29.0703C142.129 29.1484 141.895 29.2031 141.652 29.2344C141.41 29.2734 141.145 29.293 140.855 29.293C140.129 29.293 139.477 29.1953 138.898 29C138.328 28.7969 137.844 28.5234 137.445 28.1797C137.055 27.8281 136.754 27.418 136.543 26.9492C136.332 26.4727 136.227 25.957 136.227 25.4023C136.227 24.8398 136.332 24.3203 136.543 23.8438C136.762 23.3672 137.074 22.9609 137.48 22.625C137.887 22.2812 138.383 22.0156 138.969 21.8281C139.562 21.6328 140.238 21.5352 140.996 21.5352C141.551 21.5352 142.055 21.5664 142.508 21.6289C142.969 21.6836 143.395 21.7539 143.785 21.8398V21.4648C143.785 21.1602 143.727 20.8984 143.609 20.6797C143.492 20.4531 143.328 20.2695 143.117 20.1289C142.906 19.9805 142.652 19.875 142.355 19.8125C142.059 19.7422 141.734 19.707 141.383 19.707C140.648 19.707 140 19.7812 139.438 19.9297C138.883 20.0703 138.348 20.2773 137.832 20.5508L136.707 18.2773C137.504 17.7305 138.336 17.3125 139.203 17.0234C140.078 16.7344 141.004 16.5898 141.98 16.5898C142.738 16.5898 143.438 16.6758 144.078 16.8477C144.727 17.0117 145.281 17.2852 145.742 17.668C146.203 18.043 146.562 18.5352 146.82 19.1445C147.086 19.7539 147.219 20.4961 147.219 21.3711V25.7891H148.848V29H143.785V28.3438ZM141.113 26.5273C141.668 26.5273 142.172 26.4375 142.625 26.2578C143.078 26.0781 143.465 25.8594 143.785 25.6016V24.0547H140.973C140.793 24.0547 140.617 24.082 140.445 24.1367C140.273 24.1914 140.117 24.2695 139.977 24.3711C139.844 24.4727 139.734 24.5977 139.648 24.7461C139.57 24.8945 139.531 25.0664 139.531 25.2617C139.531 25.6211 139.66 25.9219 139.918 26.1641C140.184 26.4062 140.582 26.5273 141.113 26.5273ZM162.336 21.2773H159.043V20.0234C158.723 20.0234 158.43 20.0469 158.164 20.0938C157.898 20.1328 157.664 20.2031 157.461 20.3047C157.266 20.4062 157.098 20.5469 156.957 20.7266C156.824 20.9062 156.73 21.1289 156.676 21.3945V25.7891H159.148V29H151.227V25.7891H153.043V20.0703H151.25V16.8594H156.652V17.7148C156.996 17.4414 157.383 17.2305 157.812 17.082C158.242 16.9336 158.711 16.8594 159.219 16.8594C159.734 16.8594 160.266 16.8633 160.812 16.8711C161.359 16.8789 161.867 16.8828 162.336 16.8828V21.2773ZM163.988 16.8594H169.941V20.0703H169.004L170.75 24.6172L172.543 20.0703H171.5V16.8594H177.453V20.0703H176.129L171.43 31.3086H173.516V34.5195H165.98V31.3086H168.102L169.016 29L165.219 20.0703H163.988V16.8594Z"
            fill="#262A37"
          />
          <defs>
            <filter
              id="filter0_b_495_6485"
              x="-6"
              y="-6"
              width="36"
              height="44"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feGaussianBlur in="BackgroundImage" stdDeviation="3" />
              <feComposite
                in2="SourceAlpha"
                operator="in"
                result="effect1_backgroundBlur_495_6485"
              />
              <feBlend
                in="SourceGraphic"
                in2="effect1_backgroundBlur_495_6485"
                result="shape"
              />
            </filter>
            <linearGradient
              id="paint0_linear_495_6485"
              x1="8"
              y1="8"
              x2="31.5488"
              y2="40.3287"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#57AEFF" />
              <stop offset="1" stop-color="#AEE7FF" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_495_6485"
              x1="24"
              y1="1.04201e-06"
              x2="0.451206"
              y2="32.3287"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FC4747" stop-opacity="0.3" />
              <stop offset="1" stop-color="#FC4747" />
            </linearGradient>
          </defs>
        </svg>
      </a>
    </div>
    <div class="homePage__section">
      <div class="homePage__section-cards">
        <el-row :gutter="24" class="homePage__section-row">
          <el-col
            :span="8"
            v-for="(cat, index) of countcategory"
            :key="index"
            class="homePage__section-col"
          >
            <router-link :to="`/sub/${cat.id}`">
              <el-card class="homePage__section-card">
                <div class="homePage__section-flex">
                  <div>
                    <div class="homePage__section-num">
                      {{ cat.count }}
                    </div>
                    <div class="homePage__section-type">
                      {{ cat.title }}
                    </div>
                  </div>
                  <div class="dashboard__icon">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.17 2.06C20.4532 1.93653 19.7274 1.87298 19 1.87C16.5184 1.86796 14.0885 2.57957 12 3.92C9.90617 2.59717 7.47667 1.90303 5.00002 1.92C4.27267 1.92298 3.54683 1.98653 2.83002 2.11C2.59523 2.15048 2.3826 2.27346 2.23044 2.45679C2.07827 2.64013 1.99656 2.87177 2.00002 3.11V15.11C1.99788 15.2569 2.02815 15.4025 2.08867 15.5364C2.1492 15.6703 2.23849 15.7893 2.3502 15.8847C2.4619 15.9802 2.59328 16.0499 2.73498 16.0888C2.87668 16.1278 3.02522 16.135 3.17002 16.11C4.60304 15.8619 6.07123 15.9031 7.48809 16.2311C8.90495 16.5591 10.2418 17.1674 11.42 18.02L11.54 18.09H11.65C11.7609 18.1362 11.8799 18.16 12 18.16C12.1202 18.16 12.2391 18.1362 12.35 18.09H12.46L12.58 18.02C13.75 17.1483 15.083 16.5203 16.5002 16.1734C17.9173 15.8264 19.3897 15.7674 20.83 16C20.9748 16.025 21.1234 16.0178 21.2651 15.9788C21.4068 15.9399 21.5381 15.8702 21.6498 15.7747C21.7616 15.6793 21.8508 15.5603 21.9114 15.4264C21.9719 15.2925 22.0022 15.1469 22 15V3C21.9896 2.77215 21.9016 2.55471 21.7507 2.38374C21.5997 2.21276 21.3948 2.09854 21.17 2.06ZM11 15.35C9.14991 14.3767 7.09054 13.8687 5.00002 13.87C4.67002 13.87 4.34002 13.87 4.00002 13.87V3.87C4.33308 3.8508 4.66697 3.8508 5.00002 3.87C7.13341 3.86764 9.22024 4.49369 11 5.67V15.35ZM20 13.91C19.66 13.91 19.33 13.91 19 13.91C16.9095 13.9087 14.8501 14.4167 13 15.39V5.67C14.7798 4.49369 16.8666 3.86764 19 3.87C19.3331 3.8508 19.667 3.8508 20 3.87V13.91ZM21.17 18.06C20.4532 17.9365 19.7274 17.873 19 17.87C16.5184 17.868 14.0885 18.5796 12 19.92C9.91154 18.5796 7.48166 17.868 5.00002 17.87C4.27267 17.873 3.54683 17.9365 2.83002 18.06C2.69985 18.0807 2.57505 18.1268 2.46279 18.1959C2.35053 18.265 2.25302 18.3555 2.17589 18.4624C2.09876 18.5693 2.04351 18.6903 2.01333 18.8186C1.98315 18.9469 1.97862 19.0799 2.00002 19.21C2.05084 19.4697 2.20251 19.6986 2.42181 19.8467C2.64111 19.9948 2.91016 20.0499 3.17002 20C4.60304 19.7519 6.07123 19.7931 7.48809 20.1211C8.90495 20.4491 10.2418 21.0574 11.42 21.91C11.5894 22.0306 11.7921 22.0954 12 22.0954C12.2079 22.0954 12.4107 22.0306 12.58 21.91C13.7582 21.0574 15.0951 20.4491 16.512 20.1211C17.9288 19.7931 19.397 19.7519 20.83 20C21.0899 20.0499 21.3589 19.9948 21.5782 19.8467C21.7975 19.6986 21.9492 19.4697 22 19.21C22.0214 19.0799 22.0169 18.9469 21.9867 18.8186C21.9565 18.6903 21.9013 18.5693 21.8242 18.4624C21.747 18.3555 21.6495 18.265 21.5373 18.1959C21.425 18.1268 21.3002 18.0807 21.17 18.06V18.06Z"
                        fill="#0C2D66"
                      />
                    </svg>
                  </div>
                </div>
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="homePage__new">
      <div class="homePage__newTitle">Yangi qo'shilganlar</div>
      <div class="bookList__row">
        <div class="bookList__col" v-for="(book, index) of books" :key="index">
          <el-card class="book__card">
            <div>
              <router-link :to="`/book/${book._id}`">
                <el-image
                  :src="`${this.url}/${book.avatar}`"
                  fit="cover"
                  class="book__img"
                  v-if="book.avatar"
                />
                <div class="book__avatar" v-else>
                  {{ book.avatar }}
                  <img src="../assets/logo.svg" alt="" />
                </div>
              </router-link>
              <div class="book__item">
                <div class="book__category">
                  {{ book.subcategory.title }}
                </div>
                <router-link :to="`/book/${book._id}`" class="book__title">{{
                  book.title
                }}</router-link>
                <div class="book__authors">
                  <b>{{ book.author.toString() }}</b>
                </div>
                <div class="book__details">
                  <el-button
                    :class="{ book__heart: true, ok: book.fav }"
                    @click="goFavorites(book._id)"
                  >
                    <svg
                      width="35px"
                      height="35px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6 6C6 4.89543 6.89543 4 8 4H16C17.1046 4 18 4.89543 18 6V21L12 15L6 21V6Z"
                        stroke="#000"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </el-button>
                </div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      page: 1,
      pageSize: 40,
      search: "",
      activeName: "",
    };
  },
  props: ["books", "title"],

  computed: {
    ...mapGetters([
      "user",
      "searchHomeGet",
      "role",
      "toggleTheme",
      "url",
      "language",
      "headerSearch",
      "bookCount",
      "countcategory",
    ]),
  },
  watch: {
    search(val) {
      if (val.length > 0) {
        this.$store.dispatch("searchHome", val);
      } else {
        this.$store.commit("searchHome", []);
      }
    },
  },
  methods: {
    ...mapActions(["searchList", "getBookCount", "setFav", "allBookList"]),

    goList(title) {
      this.searchList(title);
      this.searchHome = "";
      this.$store.commit("searchHome", []);
      this.$router.push({ path: "/bookview", query: { title: title } });
      this.$store.commit("headerSearch", true);
    },
    goFavorites(id) {
      let list = [];
      if (this.$cookies.isKey("favapp")) {
        list = JSON.parse(this.$cookies.get("favapp"));
        let index = list.findIndex((item) => item == id);
        if (index == -1) {
          list.push(id);
          this.setFav({ id, fav: true });
          this.$message({
            message: "Tanlanganlarga qo`shildi",
            type: "success",
          });
        } else {
          list.splice(index, 1);
          this.setFav({ id, fav: false });
          this.$message({
            message: "Tanlanganlardan o`chirildi",
            type: "success",
          });
        }
        this.$cookies.set("favapp", JSON.stringify(list));
      } else {
        this.$cookies.set("favapp", JSON.stringify(list));
        this.$message({
          message: "Tanlanganlarga qo`shildi",
          type: "success",
        });
      }
    },
  },
  setup() {
    const options = {
      rewind: true,
      gap: "2rem",
      perPage: 2.5,
      type: "loop",
      pagination: false,
      perMove: 1,
      breakpoints: {
        912: {
          perPage: 2,
        },
        820: {
          perPage: 2,
        },
        768: {
          perPage: 2,
        },
        540: {
          perPage: 1,
        },
        425: {
          perPage: 1,
        },
      },
    };

    return { options };
  },
  mounted() {
    this.getBookCount();
    this.allBookList();
  },
};
</script>

<style lang="scss">
@import "@/styles/view/home.scss";
@import "@/styles/component/bookList.scss";
@import "@/styles/media.scss";
</style>
